import { useTranslation } from 'next-i18next';

export const useCategoryDescriptions = (category?: string) => {
  const { t } = useTranslation('articles');

  if (!category) return null;

  return {
    'before-the-big-day': {
      hero: t('categoryDescription.before-the-big-day.hero'),
      bottom: t('categoryDescription.before-the-big-day.bottom'),
      faq: t('categoryDescription.before-the-big-day.faq'),
    },
    engagement: {
      hero: t('categoryDescription.engagement.hero'),
      bottom: t('categoryDescription.engagement.bottom'),
      faq: t('categoryDescription.engagement.faq'),
    },
    'budget-and-costs': {
      hero: t('categoryDescription.budget-and-costs.hero'),
      bottom: t('categoryDescription.budget-and-costs.bottom'),
      faq: t('categoryDescription.budget-and-costs.faq'),
    },
    'ceremony-and-vows': {
      hero: t('categoryDescription.ceremony-and-vows.hero'),
      bottom: t('categoryDescription.ceremony-and-vows.bottom'),
      faq: t('categoryDescription.ceremony-and-vows.faq'),
    },
    'wedding-speeches': {
      hero: t('categoryDescription.wedding-speeches.hero'),
      bottom: t('categoryDescription.wedding-speeches.bottom'),
      faq: t('categoryDescription.wedding-speeches.faq'),
    },
    'wedding-fashion': {
      hero: t('categoryDescription.wedding-fashion.hero'),
      bottom: t('categoryDescription.wedding-fashion.bottom'),
      faq: t('categoryDescription.wedding-fashion.faq'),
    },
    'wedding-flowers': {
      hero: t('categoryDescription.wedding-flowers.hero'),
      bottom: t('categoryDescription.wedding-flowers.bottom'),
      faq: t('categoryDescription.wedding-flowers.faq'),
    },
    'wedding-decor-styling': {
      hero: t('categoryDescription.wedding-decor-styling.hero'),
      bottom: t('categoryDescription.wedding-decor-styling.bottom'),
      faq: t('categoryDescription.wedding-decor-styling.faq'),
    },
    'wedding-food-and-drink': {
      hero: t('categoryDescription.wedding-food-and-drink.hero'),
      bottom: t('categoryDescription.wedding-food-and-drink.bottom'),
      faq: t('categoryDescription.wedding-food-and-drink.faq'),
    },
    'wedding-entertainment-music': {
      hero: t('categoryDescription.wedding-entertainment-music.hero'),
      bottom: t('categoryDescription.wedding-entertainment-music.bottom'),
      faq: t('categoryDescription.wedding-entertainment-music.faq'),
    },
    'wedding-stationery-wording': {
      hero: t('categoryDescription.wedding-stationery-wording.hero'),
      bottom: t('categoryDescription.wedding-stationery-wording.bottom'),
      faq: t('categoryDescription.wedding-stationery-wording.faq'),
    },
    venues: {
      hero: t('categoryDescription.venues.hero'),
      bottom: t('categoryDescription.venues.bottom'),
      faq: t('categoryDescription.venues.faq'),
    },
    'stag-and-hen': {
      hero: t('categoryDescription.stag-and-hen.hero'),
      bottom: t('categoryDescription.stag-and-hen.bottom'),
      faq: t('categoryDescription.stag-and-hen.faq'),
    },
    'wedding-guests-gifting': {
      hero: t('categoryDescription.wedding-guests-gifting.hero'),
      bottom: t('categoryDescription.wedding-guests-gifting.bottom'),
      faq: t('categoryDescription.wedding-guests-gifting.faq'),
    },
    'honeymoons-travel': {
      hero: t('categoryDescription.honeymoons-travel.hero'),
      bottom: t('categoryDescription.honeymoons-travel.bottom'),
      faq: t('categoryDescription.honeymoons-travel.faq'),
    },
    'love-relationships': {
      hero: t('categoryDescription.love-relationships.hero'),
      bottom: t('categoryDescription.love-relationships.bottom'),
      faq: t('categoryDescription.love-relationships.faq'),
    },
    'real-weddings': {
      hero: t('categoryDescription.real-weddings.hero'),
      bottom: t('categoryDescription.real-weddings.bottom'),
      faq: t('categoryDescription.real-weddings.faq'),
    },
  }[category];
};
